import { useParams } from 'react-router-dom'
import { ErrorCode } from '../components/errors/constants'

type ParamsType<T extends string[]> = Record<T[number], string>

function checkAllParams<T extends string[]>(params: Record<string, unknown>, keys: T): params is ParamsType<T> {
  for (const key of keys) {
    if (!(key in params) || params[key as keyof typeof params] == null) {
      return false
    }
  }
  return true
}

export function useParamsOr404<T extends string[]>(...keys: T) {
  const result = useParams<ParamsType<T>>()
  if (!checkAllParams(result, keys)) {
    throw new Error(ErrorCode.NOT_FOUND)
  }
  return result
}
